import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/PageHeader";
import { toast } from "sonner";

export default function ChangePassword() {
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const { user, checkAuth } = useAuth();
    const required = sp.get("required") === "1" || user?.must_change_password;
    const [current, setCurrent] = useState("");
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
        if (pw !== pw2) { toast.error("Passwords don't match"); return; }
        setBusy(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: pw });
            toast.success("Password updated");
            await checkAuth();
            navigate("/dashboard");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed");
        } finally { setBusy(false); }
    };

    return (
        <div>
            <PageHeader
                eyebrow="Profile"
                title={required ? "Set a new password to continue" : "Change your password"}
                subtitle={required ? "First-time login requires a fresh password." : "Keep your account secure."}
            />
            <div className="px-8 py-6 max-w-lg">
                <form onSubmit={submit} className="space-y-5 border border-zinc-200 p-6">
                    <div className="space-y-1.5">
                        <Label className="text-[11px] uppercase tracking-wider text-zinc-500">Current password</Label>
                        <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="h-11 rounded-none" data-testid="cp-current" />
                    </div>
                    <div className="space-y-1.5">
                        <Label className="text-[11px] uppercase tracking-wider text-zinc-500">New password</Label>
                        <Input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} className="h-11 rounded-none" data-testid="cp-new" />
                    </div>
                    <div className="space-y-1.5">
                        <Label className="text-[11px] uppercase tracking-wider text-zinc-500">Confirm new password</Label>
                        <Input type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-11 rounded-none" data-testid="cp-confirm" />
                    </div>
                    <Button type="submit" disabled={busy} className="rounded-none h-11 bg-[#002FA7] hover:bg-[#00227B]" data-testid="cp-submit">
                        {busy ? "Updating…" : "Update password"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
